// extracted by mini-css-extract-plugin
module.exports = {"container":"Vi","disabled":"Wi","bgBlack":"Xi","content":"Yi","countdown":"Zi","topCaption":"_i","topHeading":"aj","heading":"bj","copy":"cj"};